










import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import Title from './components/Title.vue';
import { getRules } from '@/api/api';
@Component({
  components: {
    Title,
  },
})
export default class Four extends Vue {
  option = config.OPTHINES;
  rulesData = '';
  async created() {
    const res = await getRules(this.option.voteName);
    this.rulesData = res.data;
  }
}
